import script from "./Formulate.vue?vue&type=script&setup=true&lang=js"
export * from "./Formulate.vue?vue&type=script&setup=true&lang=js"

import "./Formulate.vue?vue&type=style&index=0&id=eb554038&lang=scss"

const __exports__ = script;

export default __exports__